import * as React from "react";

function Upload(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 22" fill="none" {...props}>
      <path
        d="M9.748 13.5h.002l.001-.001a.75.75 0 00.75-.748l.026-10.461c.744.786 1.544 1.743 1.638 1.856l.01.011a.75.75 0 101.153-.958c-.069-.084-1.703-2.049-2.643-2.848a1.46 1.46 0 00-.864-.35h-.014a1.453 1.453 0 00-.992.352c-.939.799-2.573 2.764-2.642 2.847a.75.75 0 101.154.958c.012-.015.9-1.082 1.7-1.923L9 12.748a.75.75 0 00.748.752z"
        fill="#333"
      />
      <path
        d="M10.748 21.5c3.969 0 5.961 0 7.348-1.323 1.402-1.338 1.402-3.245 1.402-7.047 0-3.802 0-5.71-1.403-7.048-.559-.532-1.256-.871-2.193-1.067a.751.751 0 00-.307 1.47c.662.138 1.114.349 1.466.684.938.894.938 2.588.938 5.96 0 3.374 0 5.068-.938 5.962-.952.909-2.744.909-6.312.909h-2c-3.568 0-5.359 0-6.312-.909-.938-.894-.938-2.588-.938-5.96 0-3.374 0-5.067.937-5.961.353-.335.806-.547 1.467-.685a.75.75 0 00-.307-1.469c-.937.196-1.634.535-2.194 1.067C0 7.421 0 9.33 0 13.13c0 3.8 0 5.71 1.402 7.047C2.79 21.5 4.782 21.5 8.75 21.5h1.998z"
        fill="#333"
      />
    </svg>
  );
}

export default Upload;
